module.exports = __webpack_public_path__ + "media/images/flags/uy-8d4599121ab86f62d1fae6a1a4b29ac9.svg";